var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"value":_vm.show,"opacity":"1","color":"#eee","absolute":""}},[_c('LoadingSpinner',{attrs:{"color":"var(--gray500)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }